<template>
  <div class="dashboard-root">
    <div v-if="isFiltering" class="dashboard-filter-overlay">
      <div class="dashboard-filter-overlay__content">
        <b-spinner variant="primary" />
        <span class="ml-75">Applying filter...</span>
      </div>
    </div>
    <b-container fluid>
      <b-row>
        <b-col md="12">
          <date-range-card />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <statistic-card />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-card ref="npscard" title="NPS">
            <nps-card />
          </b-card>
        </b-col>
        <b-col md="6">
          <b-card :style="topStyle">
            <most-viewed-product-card />
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-card>
            <top-unit-card />
          </b-card>
        </b-col>
        <b-col md="6">
          <b-card>
            <top-visitor-card />
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <view-last-days-card />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <view-month-card />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { BContainer, BRow, BCol, BCard, BSpinner } from 'bootstrap-vue'
import NpsCard from './npscard.vue'
import ProductCard from './productCard.vue'
import VisitorCard from './VisitorCard.vue'
import StatisticCard from './statistic.vue'
import MostViewedProductCard from './topDataCard.vue'
import TopUnitCard from './topUnitCard.vue'
import TopVisitorCard from './topVisitorCard.vue'
import DateRangeCard from './dateRangeCard.vue'
import ViewLastDaysCard from './viewLastDays.vue'
import ViewMonthCard from './viewsPerMonth.vue'
import { dashboardFiltering } from './services'

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BSpinner,
    NpsCard,
    ProductCard,
    VisitorCard,
    StatisticCard,
    MostViewedProductCard,
    TopUnitCard,
    TopVisitorCard,
    DateRangeCard,
    ViewMonthCard,
    ViewLastDaysCard,
  },
  data() {
    return {
      topStyle: {},
      isFiltering: false,
    }
  },
  created() {
    this.isFiltering = dashboardFiltering.value
    this.unwatchFiltering = this.$watch(
      () => dashboardFiltering.value,
      value => {
        this.isFiltering = value
      }
    )
  },
  mounted() {
    this.matchHeight()
  },
  beforeDestroy() {
    if (typeof this.unwatchFiltering === 'function') {
      this.unwatchFiltering()
    }
  },
  methods: {
    matchHeight() {
      const heightString = `${this.$refs.npscard.clientHeight}px`
      this.$set(this.topStyle, 'height', heightString)
    },
  },
}
</script>

<style lang="scss">
.dashboard-root {
  position: relative;
}

.dashboard-filter-overlay {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.55);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(1px);
}

.dashboard-filter-overlay__content {
  display: inline-flex;
  align-items: center;
  padding: 0.85rem 1.1rem;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #fff;
  color: #5e5873;
  font-weight: 600;
  box-shadow: 0 12px 28px rgba(16, 24, 40, 0.12);
}
</style>
